// 認証フォームのメールアドレス入力バリデーション

const MAX_LENGTH = 255
const FULL_WIDTH_PATTERN = /[^\x01-\x7E]/
const FORMAT_PATTERN = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/
const TRIM_PATTERN = /^[\s\u3000]+|[\s\u3000]+$/gu

export function normalizeAuthEmail(value: string): string {
  return (value ?? '').replace(TRIM_PATTERN, '')
}

// 空文字は required に委譲して null。複数該当時は最初のエラーのみ返す。
export function validateAuthEmail(value: string): string | null {
  const normalized = normalizeAuthEmail(value)
  if (normalized === '') return null

  if (normalized.length > MAX_LENGTH) return '入力された文字列が長すぎます'
  if (FULL_WIDTH_PATTERN.test(normalized)) return '全角文字が含まれています'
  if (normalized.includes(' ')) return 'スペースが含まれています'
  if (!FORMAT_PATTERN.test(normalized) || normalized.includes('..') || normalized.includes('.@')) {
    return '不正なメールアドレスが入力されています'
  }
  return null
}
